<template>
    <v-container fluid class="pa-0">
        <v-col class="pa-0">
            <table style="border: 1px solid var(--v-disabled-base); border-collapse: collapse; width: 100%;"
                class="my-3">
                <thead style="text-align: left; background-color: #f1f1f1;">
                    <tr>
                        <th class="px-3 py-2">Xml schema</th>
                    </tr>
                </thead>
                <tbody style="text-align: left; background-color: white;">
                    <tr>
                        <td class="px-3">
                            <v-btn v-if="sampleFileView.XmlSchema" color="primary" text style="text-transform: none;"
                                class="d-flex justify-start px-0"
                                @click="downloadSampleFile({ fileName: sampleFileView.XmlSchema.FileName })">
                                <v-icon size="20" class="mr-1">mdi-file-xml-box</v-icon>
                                XML schema
                            </v-btn>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table style="border: 1px solid var(--v-disabled-base); border-collapse: collapse; width: 100%;">
                <thead style="text-align: left; background-color: #f1f1f1;">
                    <tr>
                        <th class="px-3 py-2">Sample import files</th>
                        <th style="width: 36px;">
                            <v-btn icon @click="trigger++">
                                <v-icon size="20">mdi-upload</v-icon>
                            </v-btn>
                        </th>
                    </tr>
                </thead>
                <tbody style="text-align: left; background-color: white;">
                    <tr>
                        <td class="px-3">
                            <v-btn v-if="sampleFileView.FullExcelSample" color="primary" text
                                style="text-transform: none;" class="d-flex justify-start px-0"
                                @click="downloadSampleFile({ fileName: sampleFileView.FullExcelSample.FileName })">
                                <v-icon size="20" class="mr-1">mdi-microsoft-excel</v-icon>
                                Excel
                            </v-btn>
                        </td>
                    </tr>
                    <tr>
                        <td class="px-3">
                            <v-btn v-if="sampleFileView.FullXmlSample" color="primary" text
                                style="text-transform: none;" class="d-flex justify-start px-0"
                                @click="downloadSampleFile({ fileName: sampleFileView.FullXmlSample.FileName })">
                                <v-icon size="20" class="mr-1">mdi-file-xml-box</v-icon>
                                Xml
                            </v-btn>
                        </td>
                    </tr>
                    <template v-if="sampleFileView.DynamicFiles">
                        <tr v-for="sampleFile in sampleFileView.DynamicFiles" :key="sampleFile.FileName">
                            <td class="px-3">
                                <v-btn color=" primary" text style="text-transform: none; "
                                    class="d-flex justify-start px-0"
                                    @click="downloadSampleFile({ fileName: sampleFile.FileName })">
                                    <v-icon size="20" class="mr-1">mdi-microsoft-excel</v-icon>
                                    <p class="ma-0 nowrapheader" style="max-width: 350px;">
                                        {{ sampleFile.DisplayName }}
                                    </p>
                                </v-btn>
                            </td>
                            <td style="width: 36px;">
                                <v-btn icon @click="removeSampleFile({ fileName: sampleFile.FileName })">
                                    <v-icon size="20">mdi-delete</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>

            <UploadDialog :externaltrigger="trigger" multiple :accept="'.xlsx,.xls,.xml'"
                :uploadFunc="uploadNewSampleFiles">
            </UploadDialog>
        </v-col>
    </v-container>
</template>


<script>
import ClientAPIMixin from '@/api/ClientAPIMixin';
import BlobFileMixin from "@/helpers/Mixins/BlobFileMixin";
import UploadDialog from '@/components/Dialogs/UploadDialog3.vue';

export default {
    name: 'ImportSamples',
    props: {},
    components: {
        UploadDialog,
    },
    mixins: [ClientAPIMixin],

    data() {
        return {
            sampleFileView: {},
            loading: false,
            trigger: 1,
        };
    },

    mounted() {
        this.fetch();
    },

    methods: {
        async fetch() {
            this.loading = true;
            this.getSampleFiles()
                .then((response) => {
                    this.sampleFileView = response;
                }).finally(() => {
                    this.loading = false;
                });
        },

        async downloadSampleFile({ fileName, }) {
            await this.getSampleFile({ fileName })
                .then((response) => {
                    var blob = new Blob([response.data], { type: response.headers['content-type'] });
                    var fileName = BlobFileMixin.methods.getFileNameFromResponseContentDisposition(response);
                    BlobFileMixin.methods.saveBlobToFile(blob, fileName);
                });
        },

        async uploadNewSampleFiles(file) {
            await this.uploadSampleFiles(file)
                .then(() => {
                    this.fetch();
                });
        },

        async removeSampleFile({ fileName, }) {
            await this.deleteSampleFile({ fileName })
                .then(() => {
                    this.fetch();
                });
        },

        getFileNameFromContentDisposition(contentDisposition) {
            var fileName = "";
            if (contentDisposition.includes('filename="')) {
                fileName = contentDisposition.split('filename="')[1].split('";')[0];
            }
            else {
                fileName = contentDisposition.split('filename=')[1].split(';')[0];
            }
            return fileName;
        },
    },

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>